/**
 * Ledighetssjekk i handlekurven – Gaulin Utleie.
 *
 * Lastes fra temaets snutt gu-kurv-booking.liquid (assets/gu-kurv-ledighet.js) –
 * og kan i tillegg slås på som app-embed «Ledighetssjekk (Gaulin)»; dobbel
 * lasting er ufarlig (guKurvLedighetKlar). Når kunden har valgt leiedatoer,
 * spørres bookingappen om alle varene i kurven er ledige i perioden. Er noe
 * opptatt, vises en boks med hva som mangler, og Kasse/«Send bestilling»/
 * hurtigkasse sperres til datoene eller antallet endres.
 *
 * Sjekken kjøres ved sidelast, ved datovalg, ved hver endring i kurven
 * (antall, fjern, legg til – også via AJAX) OG i selve klikket på kassen: da
 * hentes et ferskt svar før kunden slippes videre. Det siste er viktig – uten
 * det kunne kunden endre antall etter at datoene var sjekket og likevel gå
 * til kassen (slik ble det bestilt flere hvite stoler enn vi har).
 *
 * Feiler trygt: hvis appen ikke svarer (404/nettfeil), skjer ingenting –
 * kurven virker som før.
 */
(function () {
  if (window.guKurvLedighetKlar) return;
  window.guKurvLedighetKlar = true;

  var PROXY = "/apps/booking/availability";
  var BOKS_ID = "gu-ledighet-boks";
  var FERSK_MS = 20000; // så gammelt kan et «alt ledig»-svar være når kunden trykker Kasse
  var sjekkNr = 0;
  var paagaaende = null; // Promise for sjekken som kjører nå
  var siste = null; // { tid, ok, opptatt: [] , nokkel }
  var slippGjennom = false; // satt når vi selv re-klikker etter godkjent sjekk
  var timer = null;

  function datoer() {
    var s = document.querySelector(".gu-kb-start");
    var e = document.querySelector(".gu-kb-slutt");
    return { start: s ? s.value : "", slutt: e ? e.value : "" };
  }

  var KASSE = 'button[name="checkout"], input[name="checkout"], #checkout, #gu-bet-send, a[href="/checkout"], a[href^="/checkout?"]';
  var HURTIG = ".cart__dynamic-checkout-buttons, .additional-checkout-buttons, shopify-accelerated-checkout-cart";

  function kasseknapper() {
    return Array.prototype.slice.call(document.querySelectorAll(KASSE));
  }

  function sperr(av) {
    kasseknapper().forEach(function (b) {
      if (av) {
        if (!b.hasAttribute("data-gu-sperret")) {
          b.setAttribute("data-gu-sperret", "1");
          b.setAttribute("data-gu-opacity", b.style.opacity || "");
        }
        b.style.opacity = "0.5";
        b.setAttribute("aria-disabled", "true");
      } else if (b.hasAttribute("data-gu-sperret")) {
        b.style.opacity = b.getAttribute("data-gu-opacity") || "";
        b.removeAttribute("data-gu-sperret");
        b.removeAttribute("data-gu-opacity");
        b.removeAttribute("aria-disabled");
      }
    });
    // Hurtigkasse (Shop Pay/Vipps-knapper) går utenom klikk-sperren – skjul dem.
    Array.prototype.slice.call(document.querySelectorAll(HURTIG)).forEach(function (h) {
      if (av) {
        h.setAttribute("data-gu-sperret", "1");
        h.style.pointerEvents = "none";
        h.style.opacity = "0.3";
      } else if (h.hasAttribute("data-gu-sperret")) {
        h.removeAttribute("data-gu-sperret");
        h.style.pointerEvents = "";
        h.style.opacity = "";
      }
    });
  }

  function fjernBoks() {
    var b = document.getElementById(BOKS_ID);
    if (b) b.remove();
  }

  function altOk() { fjernBoks(); sperr(false); }

  function visBoks(html) {
    fjernBoks();
    var vert = document.querySelector(".gu-kurv-booking") || document.querySelector('form[action="/cart"]');
    if (!vert) return;
    var d = document.createElement("div");
    d.id = BOKS_ID;
    d.setAttribute("role", "alert");
    d.style.cssText =
      "margin:12px 0;padding:12px 14px;border:1px solid #b3261e;border-radius:8px;" +
      "background:rgba(179,38,30,.07);font-size:.9em;line-height:1.5;";
    d.innerHTML = html;
    vert.parentNode.insertBefore(d, vert.nextSibling);
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function visOpptatt(opptatt) {
    var linjer = opptatt.map(function (i) {
      var ledig = Math.max(0, i.requested - i.shortfall);
      return "<li><strong>" + esc(i.title) + "</strong>: " +
        (ledig === 0 ? "ikke ledig" : "bare " + ledig + " ledig") +
        " i valgt periode (du ba om " + i.requested + ")</li>";
    }).join("");
    visBoks(
      "<strong>Ikke ledig i valgt periode</strong>" +
      "<ul style=\"margin:6px 0 0 18px;padding:0\">" + linjer + "</ul>" +
      "<div style=\"margin-top:6px\">Sett ned antallet eller prøv andre datoer – eller ring 97 96 90 34, " +
      "så ser vi om vi løser det likevel.</div>"
    );
    sperr(true);
    var b = document.getElementById(BOKS_ID);
    if (b && b.scrollIntoView) b.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  /**
   * Sjekker kurven mot appen. Løser til { ok: true } når alt er ledig eller
   * sjekken ikke lot seg gjøre (appen nede / ingen datoer), ellers
   * { ok: false, opptatt: [...] }. Oppdaterer boksen og sperren selv.
   */
  function sjekk() {
    var v = datoer();
    if (!v.start || !v.slutt) { altOk(); siste = null; return Promise.resolve({ ok: true }); }
    var mitt = ++sjekkNr;

    var p = fetch("/cart.js", { cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (kurv) {
        var antall = {};
        (kurv.items || []).forEach(function (i) {
          if (i.handle) antall[i.handle] = (antall[i.handle] || 0) + i.quantity;
        });
        var items = Object.keys(antall).map(function (h) { return h + ":" + antall[h]; }).join(",");
        if (!items) { altOk(); return { ok: true }; }

        return fetch(PROXY + "?start=" + v.start + "&end=" + v.slutt + "&items=" + encodeURIComponent(items), { cache: "no-store" })
          .then(function (r) {
            if (!r.ok) throw new Error("proxy " + r.status);
            return r.json();
          })
          .then(function (svar) {
            if (mitt !== sjekkNr) return { ok: true, utdatert: true }; // nyere sjekk er alt i gang
            if (!svar || !svar.ok) { altOk(); return { ok: true }; }
            var opptatt = (svar.items || []).filter(function (i) { return !i.available; });
            siste = { tid: Date.now(), ok: !opptatt.length, opptatt: opptatt, nokkel: v.start + "|" + v.slutt + "|" + items };
            if (!opptatt.length) { altOk(); return { ok: true }; }
            visOpptatt(opptatt);
            return { ok: false, opptatt: opptatt };
          });
      })
      .catch(function () {
        if (mitt === sjekkNr) { altOk(); siste = null; }
        return { ok: true, feil: true };
      });
    paagaaende = p;
    p.then(function () { if (paagaaende === p) paagaaende = null; });
    return p;
  }

  function sjekkSnart(ms) {
    clearTimeout(timer);
    timer = setTimeout(sjekk, ms == null ? 400 : ms);
  }

  // ---- Utløsere ----
  document.addEventListener("change", function (e) {
    var el = e.target;
    if (!el || !el.classList) return;
    if (el.classList.contains("gu-kb-start") || el.classList.contains("gu-kb-slutt")) {
      sjekkSnart(150); // la temaets eget script lagre datoene først
    } else if (el.name === "updates[]" || /quantity/i.test(el.name || "")) {
      sjekkSnart(900); // temaet oppdaterer kurven via AJAX først
    }
  });
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest("cart-remove-button, .quantity__button, [name='plus'], [name='minus']")) sjekkSnart(1200);
  });

  // Alle kurvendringer går gjennom Shopifys AJAX-API – lytt på dem uansett hvem som kaller.
  if (window.fetch) {
    var opprFetch = window.fetch;
    window.fetch = function (inn, init) {
      var url = typeof inn === "string" ? inn : (inn && inn.url) || "";
      var res = opprFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        res.then(function () { sjekkSnart(300); }, function () {});
      }
      return res;
    };
  }

  window.addEventListener("pageshow", function (e) { if (e.persisted) sjekkSnart(0); });

  // ---- Sperre i selve klikket: ferskt svar før kassen ----
  function fersk() {
    return siste && siste.ok && Date.now() - siste.tid < FERSK_MS;
  }
  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(KASSE) : null;
    if (!btn) return;
    if (slippGjennom) return;
    var v = datoer();
    if (!v.start || !v.slutt) return; // temaets egen sperre ber om datoer
    if (siste && !siste.ok) {
      e.preventDefault(); e.stopImmediatePropagation();
      visOpptatt(siste.opptatt);
      sjekk(); // i tilfelle noe er endret siden sist
      return;
    }
    if (fersk() && !paagaaende) return; // nylig bekreftet ledig – slipp gjennom
    e.preventDefault(); e.stopImmediatePropagation();
    var org = btn.textContent;
    if (btn.tagName === "BUTTON") btn.textContent = "Sjekker ledighet …";
    (paagaaende || sjekk()).then(function (svar) {
      if (btn.tagName === "BUTTON") btn.textContent = org;
      if (!svar || svar.ok === false) return; // boksen er vist, knappen sperret
      slippGjennom = true;
      try { btn.click(); } finally { slippGjennom = false; }
    });
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sjekk);
  else sjekk();
})();
